import { getAdminParentMessengerToken } from './admin-parent-auth.js';

/**
 * Auth credential priority (orchestrated by tinode-web):
 * 1. Valid session token in localStorage
 * 2. JWT from webview bridge, then admin-portal postMessage
 *
 * These helpers only cover step 2.
 */

// getJWTFromBridge extracts a JWT injected by native app/webview bridge.
export function getJWTFromBridge() {
  const token = (globalThis.__ANGKAS_JWT__ || '').trim();
  if (token) {
    // Keep token in-memory only; clear shared global immediately.
    delete globalThis.__ANGKAS_JWT__;
  }
  return token;
}

// discoverJWTToken collects a JWT: webview bridge → admin-portal postMessage.
export function discoverJWTToken() {
  return getJWTFromBridge() || getAdminParentMessengerToken();
}
